import React, { useState, useEffect } from "react";
import "../../global.scss";
import "./addVehicle.scss";
import "../OnBoarding/MyVehicles.scss";

import {
  IonRow,
  IonCol,
  IonText,
  IonLabel,
  IonIcon,
  IonAlert,
  IonButton,
  isPlatform,
} from "@ionic/react";
import {
  MY_VEHICLES,
  LAST_SERVICE,
  ODOMETER,
  DEFAULT,
  EDIT,
  DELETE,
  ADD_ANOTHER_VEHICLE,
  ADD_VEHICLE,
  CHOOSE_FROM,
  THREE_THOUSAND_PLUS,
  MODELS,
  MAKE_DEFAULT,
  ARE_YOU_SURE_YOU_WANT_DELETE_VEHICLE,
  DELETE_VEHICLE,
} from "../../constants";

import { chevronBackOutline } from "ionicons/icons";
import { connect } from "react-redux";
import {
  COLLECTIONS,
  deleteDataFromFireStore,
  deleteVehicleRef,
  getDoc,
  updateDoc,
  updateVehicleRef,
} from "../../firebase";
import {
  updateEditedUserDetails,
  deleteVehicle,
  saveCatelogVehicleId,
  deleteCartItemList,
  updateBookingSummary,
} from "../../Store/Actions";
import { AlertMessage } from "../../utils/alertMessage";
import { checkMediaQuery } from "../../utils";
import { ToastMessage } from "../../utils/toastMessage";

const MyVehicles: React.FC = (props: any) => {
  const [showDeleteAddress, setShowDeleteAddress] = useState(false);
  const [deleteVehicleId, setDeleteVehicleId] = useState("");
  const [state, setState] = useState("");
  const [toast, setToast] = React.useState({
    showToast: false,
    toastMessage: "",
    severity: "",
  });

  React.useEffect(() => {
    setState(props.hasOwnProperty("defaultVehicleRef") ? props.defaultVehicleRef || "" : "");
  }, [props.defaultVehicleRef]);

  const updateDefaultVehicleRef = async (vehicleId: any) => {
    const payload: any = {
      defaultVehicleRef: `${COLLECTIONS.USERS}/${props.uid}/${COLLECTIONS.VECHICLES}/${vehicleId}`,
    };
    updateVehicleRef(props.uid, vehicleId, COLLECTIONS.USERS, COLLECTIONS.VECHICLES);
    await props.updateEditedUserDetails(payload);
    setState(payload.defaultVehicleRef);
  };

  const deleteVehicleData = async () => {
    try {
      if ((props.bookingList || []).length) {
        const vehicleDetails = props.userVehiclesList.find(
          (ele: any) => ele.did === deleteVehicleId,
        );
        const carIds = props.bookingList
          .map((ele: any) => {
            if (ele.status === "InProgress") {
              return ele.userVehicleId;
            }
          })
          .filter((ele: any) => ele);
        if (carIds.includes(vehicleDetails.catalogVehicleId)) {
          throw Error("This vehicle has active booking");
        }
      }
      const data: any = props.userVehiclesList.filter((ele: any) => ele.did !== deleteVehicleId);
      if (deleteVehicleId === props.defaultVehicleRef.split("/").pop()) {
        const vehicleData = props.userVehiclesList.find((ele: any) => ele.did === deleteVehicleId);
        if (vehicleData.hasOwnProperty("documentIds") && vehicleData.documentIds.length) {
          vehicleData.documentIds.map(
            async (ele: any) =>
              await deleteDataFromFireStore(
                props.uid,
                ele.did,
                COLLECTIONS.USERS,
                COLLECTIONS.DOCUMENTS,
              ),
          );
        }
        if (data.length) {
          await updateVehicleRef(props.uid, data[0].did, COLLECTIONS.USERS, COLLECTIONS.VECHICLES);
        } else {
          await deleteVehicleRef(props.uid, COLLECTIONS.USERS);
        }
        await props.updateEditedUserDetails({
          defaultVehicleRef: data.length
            ? `${COLLECTIONS.USERS}/${props.uid}/${COLLECTIONS.VECHICLES}/${data[0].did}`
            : "",
        });
      }
      if (deleteVehicleId === props.selectedVehicleRef.split("/").pop()) {
        await props.updateEditedUserDetails({
          selectedVehicleRef: data.length
            ? `${COLLECTIONS.USERS}/${props.uid}/${COLLECTIONS.VECHICLES}/${data[0].did}`
            : "",
        });
        await props.saveCatelogVehicleId(data.length ? data[0].catalogVehicleId : "");
      }
      const response: any = await deleteDataFromFireStore(
        props.uid,
        deleteVehicleId,
        COLLECTIONS.USERS,
        COLLECTIONS.VECHICLES,
      );

      await props.deleteVehicle(deleteVehicleId);
      if (response.success) {
        setShowDeleteAddress(false);
      }
      if (data.length === 0 && !!props.service_data.length) {
        props.deleteCartItemList();
        props.updateBookingSummary([]);
      }
    } catch (e: any) {
      setShowDeleteAddress(false);
      setToast({
        showToast: true,
        toastMessage: e.message,
        severity: "danger",
      } as any);
    }
  };
  return (
    <>
      <IonCol className="middle_panle res_bg_color" size-md="6">
        {isPlatform("ios") && <div className="ios_statusbar_color" />}
        <div
          className="personal_details_div my_veh_header_float"
          style={{ paddingTop: isPlatform("android") ? 20 : 0 }}
        >
          <div className="personal_details_div_child paddingLeft25 wholeApp">
            <img
              src={checkMediaQuery() ? "/images/gray_backarrow.svg" : "/images/back_arrow.svg"}
              className="back_arrow"
              onClick={() => props.history.goBack()}
            />
            <IonLabel className="personal_details_labels" color="secondary">
              {MY_VEHICLES}
            </IonLabel>
            <div />
          </div>
        </div>
        <div
          className={
            isPlatform("ios")
              ? "personal_details_text my_vehicles myveh_container myVeh_container_ios"
              : "personal_details_text my_vehicles myveh_container"
          }
        >
          <div className="personal_details_div padding-top-20">
            <IonRow>
              {props.userVehiclesList.map((ele: any, index: any) => (
                <IonCol
                  className="my_vehicles_body"
                  color="light"
                  key={index}
                  size-md="5.6"
                  size="12"
                >
                  {state.split("/").pop() === ele.did && (
                    <div className="default_text">
                      <IonLabel>{DEFAULT}</IonLabel>
                    </div>
                  )}

                  <div>
                    <IonLabel className="vehicle_name" color="secondary">
                      {ele.make} {ele.model}
                    </IonLabel>
                    <IonText className="vehicle_year" color="tertiary">
                      {ele.year}
                      {","} {ele.fuelType}
                    </IonText>
                    <IonText className="vehicle_service" color="tertiary">
                      {LAST_SERVICE} <span className="service_date">{ele.service || "N/A"}</span>
                    </IonText>
                    <IonText className="vehicle_service" color="tertiary">
                      {ODOMETER}{" "}
                      {!!ele.odometer ? (
                        <span className="service_date">
                          {/* {ele.odometer > 999
                            ? Math.abs(ele.odometer / 1000).toFixed(2) + "K"
                            : ele.odometer} */}
                          {ele.odometer}
                        </span>
                      ) : (
                        <span className="service_date">{"N/A"}</span>
                      )}
                    </IonText>
                  </div>
                  <div className="my_vehicles_car_details">
                    <img
                      src={ele.hasOwnProperty("imageUrl") ? ele.imageUrl : ""}
                      className="vehicle_img"
                    />
                    <div className="action_btns">
                      <IonButton
                        color="darkpink"
                        className="vehicle-actions"
                        onClick={() => props.history.push(`/portal/manage-your-vehicle/${ele.did}`)}
                      >
                        {EDIT} |{" "}
                      </IonButton>
                      <IonButton
                        color="darkpink"
                        className="vehicle-actions"
                        onClick={() => {
                          setShowDeleteAddress(true);
                          setDeleteVehicleId(ele.did);
                        }}
                      >
                        {DELETE}
                      </IonButton>

                      {state.split("/").pop() !== ele.did && (
                        <IonButton
                          color="darkpink"
                          className="vehicle-actions"
                          onClick={() => updateDefaultVehicleRef(ele.did)}
                        >
                          {" "}
                          | {MAKE_DEFAULT}
                        </IonButton>
                      )}
                    </div>
                  </div>
                </IonCol>
              ))}
            </IonRow>
          </div>
          <div className="personal_details_div add_my_vehicle">
            <IonRow>
              <IonCol
                className="my_vehicles_body add_vehicle_body"
                color="light"
                size-md="5.6"
                size="12"
                onClick={() => props.history.push("/portal/add-vehicles")}
                style={{
                  marginTop: !props.userVehiclesList.length && isPlatform("ios") ? 22 : 0,
                }}
              >
                <div>
                  {props.userVehiclesList.length ? (
                    <IonLabel className="add_my_vehicle_text" color="primary">
                      {ADD_ANOTHER_VEHICLE}
                    </IonLabel>
                  ) : (
                    <IonLabel className="add_my_vehicle_text" color="primary">
                      {ADD_VEHICLE}
                    </IonLabel>
                  )}

                  <IonLabel className="choose_models">
                    {CHOOSE_FROM}
                    <span className="models_plus">{THREE_THOUSAND_PLUS}</span> {MODELS}
                  </IonLabel>
                </div>
                <div className="add_img">
                  <img src="/images/add-vehicle.svg" />
                </div>
              </IonCol>
            </IonRow>
          </div>
        </div>
        <AlertMessage
          showAlert={showDeleteAddress}
          alertMessage={ARE_YOU_SURE_YOU_WANT_DELETE_VEHICLE}
          onDidDismiss={() => {
            setDeleteVehicleId("");
            setShowDeleteAddress(false);
          }}
          alertHeader={DELETE_VEHICLE}
          actionItemForAlert={async () => {
            deleteVehicleData();
          }}
          cssClass={"alert-message"}
        />
        <ToastMessage
          showToast={toast.showToast}
          ToastMessage={toast.toastMessage}
          severity={toast.severity}
          onDidDismiss={() => {
            setToast({
              showToast: false,
              toastMessage: "",
              severity: "",
            });
          }}
        />
      </IonCol>
    </>
  );
};

export default connect(
  ({
    auth,
    userInfo: { userVehiclesList, userAddressList },
    addVehicles: { modelsData },
    cart: { service_data },
    booking: { bookingList },
  }: any) => ({
    ...auth,
    userVehiclesList,
    userAddressList,
    modelsData,
    service_data,
    bookingList,
  }),
  {
    updateEditedUserDetails,
    deleteVehicle,
    saveCatelogVehicleId,
    deleteCartItemList,
    updateBookingSummary,
  },
)(MyVehicles);
